import React from 'react';

export default function withSkeleton(Skeleton, Component) {
  return function({ skeletonLoading, ...rest }) {
    return skeletonLoading ? <Skeleton /> : <Component {...rest} />;
  };
}
